exports.wrapPageElement = require('./gatsby-share');